const FieldCannotBeBlank = "The field cannot be blank";


export const FormErrorMessages = {
    FieldCannotBeBlank
}